import { collabStateManager } from '@databases/collab-state-manager';
import { subscribe } from 'valtio';

import { hasActiveAiFieldRunForEntry } from '../ai-field-run-awareness.ts';

import type { AiFieldCellRequestTarget } from './ai-field-cell-request-coordinator';

export const waitForAiFieldRunIdle = async ({
  contentId,
  aiFieldType,
  fieldId,
  entryId,
  isTargetValueEmpty
}: AiFieldCellRequestTarget): Promise<void> => {
  const target = { aiFieldType, fieldId, entryId, isTargetValueEmpty };
  const isIdle = (): boolean => {
    const currentManager = collabStateManager.getCollabManager(contentId);
    return (
      !currentManager || !hasActiveAiFieldRunForEntry(currentManager.aiFieldRuns, target)
    );
  };
  const manager = collabStateManager.getCollabManager(contentId);
  if (!manager || isIdle()) {
    return;
  }

  await new Promise<void>((resolve) => {
    let didResolve = false;
    let unsubscribe = (): void => undefined;
    const finish = (): void => {
      if (didResolve) {
        return;
      }
      didResolve = true;
      unsubscribe();
      resolve();
    };
    unsubscribe = subscribe(
      manager.aiFieldRuns,
      () => {
        if (isIdle()) {
          finish();
        }
      },
      true
    );

    if (isIdle()) {
      finish();
    }
  });
};
